import "./style/index.scss";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { setTitle } from "../../../../redux/slices/configuracoes/configuracoesSlice";
import { Card, List, Image, Flex, Skeleton } from "antd";
import { buscarConfiguracaoResultadoSorteio } from "../../../../services/configuracaoResultadoSorteioService";
import { ConfiguracaoResultadoSorteioVMModel } from "../../../../models/configuracaoResultadoSorteio/configuracaoResultadoSorteioVMModel";
import { EditOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { formatPercent } from "../../../../util/dinheiroBRAuxiliar";
import {
  setEntityConfiguracaoResultadoSorteio,
  setEditarConfiguracaoResultadoSorteio,
  setPageConfiguracaoResultadoSorteio,
} from "../../../../redux/slices/configuracaoResultadoSorteio/configuracaoResultadoSorteioSlice";
import { buscarEmpresa } from "../../../../services/empresaService";
import { verificarPermissaoEmpresa } from "../../../../util/functions/verificarPermissaoEmpresa";

const listaLegenda = [
  {
    id: "1",
    title: "ENTIDADE",
    content: ["% Bonificação", "% Resultado"],
  },
  {
    id: "2",
    title: "CAPITALIZAÇÃO",
    content: ["% Capitalização", "% Ressarcimento de encargos", "% Imposto ressarcimento de prejuízo", "% Revendedor"],
  },
  {
    id: "3",
    title: "",
    content: ["% Promoção Venda/Revendedor"],
  },
];

const GeralPage = () => {
  //estados globais
  const configuracaoResultadoSorteioState = useAppSelector((state) => state.configuracaoResultadoSorteio);
  const empresaState = useAppSelector((state) => state.empresa);
  const persistedState = useAppSelector((state) => state.persisted);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais

  useEffect(() => {
    dispatch(setTitle("CONFIGURAÇÕES DE RESULTADO DO SORTEIO"));
    dispatch(buscarConfiguracaoResultadoSorteio());
    dispatch(buscarEmpresa(empresaState.busca));
  }, []);

  const goCadastrar = (value: ConfiguracaoResultadoSorteioVMModel) => {
    dispatch(setEntityConfiguracaoResultadoSorteio(value));
    dispatch(setEditarConfiguracaoResultadoSorteio(false));
    dispatch(setPageConfiguracaoResultadoSorteio("cadastrar"));
  };

  const goEditar = (value: ConfiguracaoResultadoSorteioVMModel) => {
    dispatch(setEntityConfiguracaoResultadoSorteio(value));
    dispatch(setEditarConfiguracaoResultadoSorteio(true));
    dispatch(setPageConfiguracaoResultadoSorteio("cadastrar"));
  };

  return (
    <Flex gap={12} className="cardsRow">
      {configuracaoResultadoSorteioState.loading ? (
        <Flex gap={12}>
          <Skeleton.Button style={{ width: 350, height: 300 }} active block />
          <Skeleton.Button style={{ width: 150, height: 380 }} active block />
          <Skeleton.Button style={{ width: 150, height: 380 }} active block />
          <Skeleton.Button style={{ width: 150, height: 380 }} active block />
          <Skeleton.Button style={{ width: 150, height: 380 }} active block />
          <Skeleton.Button style={{ width: 150, height: 380 }} active block />
        </Flex>
      ) : (
        <Flex gap={12}>
          <Flex>
            <List
              dataSource={listaLegenda}
              rowKey="id"
              renderItem={(item, index) => (
                <List.Item key={index}>
                  <Card title={item.title} className="legendaCard">
                    {item.content.map((a) => (
                      <div key={a}>
                        <span>{a}</span>
                      </div>
                    ))}
                  </Card>
                </List.Item>
              )}
            />
          </Flex>
          <Flex gap={12} className="contentRow">
            <List
              dataSource={configuracaoResultadoSorteioState.list.slice().sort((a, b) => a.apelido.localeCompare(b.apelido))}
              rowKey="id"
              renderItem={(item: ConfiguracaoResultadoSorteioVMModel, index) => (
                <List.Item key={index}>
                  <Card
                    title={<Image style={{ height: "54px", width: "120px", objectFit: "fill" }} src={item.logoTipoEmpresa} preview={false} />}
                    actions={
                      persistedState.user.perfil === "AUDITORIA" || persistedState.user.perfil === "CORPORATIVO"
                        ? []
                        : item.editavel
                        ? item.percentualBonificacao_Entidade !== null
                          ? [<PlusCircleOutlined onClick={() => goCadastrar(item)} />, <EditOutlined onClick={() => goEditar(item)} />]
                          : [<PlusCircleOutlined onClick={() => goCadastrar(item)} />, <EditOutlined style={{ cursor: "not-allowed" }} />]
                        : [<PlusCircleOutlined onClick={() => goCadastrar(item)} />, <EditOutlined style={{ cursor: "not-allowed" }} />]
                    }
                  >
                    <div className="contentCard">
                      <span>{item.percentualBonificacao_Entidade !== null ? formatPercent(item.percentualBonificacao_Entidade) : "---"}</span>
                      <span
                        style={{
                          marginTop: 1,
                        }}
                      >
                        {item.percentualResultado_Entidade !== null ? formatPercent(item.percentualResultado_Entidade) : "---"}
                      </span>
                      <span
                        style={{
                          marginTop: 110,
                        }}
                      >
                        {item.percentualDA_Capitalizacao !== null ? formatPercent(item.percentualDA_Capitalizacao) : "---"}
                      </span>
                      <span
                        style={{
                          marginTop: 2,
                        }}
                      >
                        {item.percentualRessarcimentoEncargos_Capitalizacao !== null ? formatPercent(item.percentualRessarcimentoEncargos_Capitalizacao) : "---"}
                      </span>
                      <span
                        style={{
                          marginTop: 2,
                        }}
                      >
                        {item.percentualImpostoRessarcimentoPrejuizo_Capitalizacao !== null ? formatPercent(item.percentualImpostoRessarcimentoPrejuizo_Capitalizacao) : "---"}
                      </span>
                      <span
                        style={{
                          marginTop: 2,
                        }}
                      >
                        {item.percentualRevendedor_Capitalizacao !== null ? formatPercent(item.percentualRevendedor_Capitalizacao) : "---"}
                      </span>
                      <span
                        style={{
                          marginTop: 55,
                        }}
                      >
                        {item.percentualPromocaoVendaRevendedor !== null ? formatPercent(item.percentualPromocaoVendaRevendedor) : "---"}
                      </span>
                    </div>
                  </Card>
                </List.Item>
              )}
            />
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};

export default GeralPage;
